import React from 'react';
import PropTypes from 'prop-types';

import { LIMITED_TIME_OFFER_BANNER_VARIANT } from '../../constants/campaignPromoVariants';
import { ELEVATED_CAMPAIGN_PROMO_UI } from '../../constants/elevatedCampaignPromoUi';

const LIMITED_TIME_OFFER_BANNER_VARIANTS = Object.values(
  LIMITED_TIME_OFFER_BANNER_VARIANT,
);

/** Gold checkout callout (Figma: #FFD682 / yellow-10). */
const LimitedTimeOfferBanner = ({
  variant = LIMITED_TIME_OFFER_BANNER_VARIANT.CHECKOUT,
}) => {
  const { limitedTimeBadge } = ELEVATED_CAMPAIGN_PROMO_UI;

  if (variant === LIMITED_TIME_OFFER_BANNER_VARIANT.COMPACT) {
    return (
      <div
        className="relative z-20 inline-flex flex-col items-center whitespace-nowrap rounded-t-lg bg-yellow-10 px-6 pb-1 pt-2 text-center font-hg-sans text-gray-90"
        data-qa-target="limited-time-offer-badge"
      >
        <span className="text-sm font-semibold leading-[21px]">
          {limitedTimeBadge.title}
        </span>
        <span className="text-xs font-extralight leading-[18px]">
          {limitedTimeBadge.ends}
        </span>
      </div>
    );
  }

  const suffixText = limitedTimeBadge.checkoutSuffix.trim();

  return (
    <div
      className="box-border flex w-full max-w-full shrink-0 items-center overflow-hidden rounded-t-lg bg-yellow-10 px-6 py-1.5 font-hg-sans text-gray-90 min-[1280px]:w-fit min-[1280px]:min-h-[29px] min-[1280px]:py-1"
      data-qa-target="limited-time-offer-banner"
    >
      {/* Two lines below 1280px (split checkout column + tablet) */}
      <div className="flex w-full min-w-0 flex-col gap-0.5 text-left min-[1280px]:hidden">
        <span className="text-sm font-semibold leading-[21px]">
          {limitedTimeBadge.titleCheckout}
        </span>
        <span className="break-words text-xs font-extralight leading-[18px]">
          {suffixText}
        </span>
      </div>
      {/* 1280px+: one line tab (Figma 7757:13007) */}
      <p className="hidden min-w-0 text-center text-sm leading-[21px] whitespace-nowrap min-[1280px]:block">
        <span className="font-semibold">{limitedTimeBadge.titleCheckout}</span>
        <span className="text-xs font-extralight leading-[18px]">
          {` ${suffixText}`}
        </span>
      </p>
    </div>
  );
};

LimitedTimeOfferBanner.propTypes = {
  variant: PropTypes.oneOf(LIMITED_TIME_OFFER_BANNER_VARIANTS),
};

export default LimitedTimeOfferBanner;
